import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/usps': {
    width: 522,
    height: 512,
    paths: [
      {
        d: 'M433.3 241.8C459.1 200.5 448.5 193 421.6 193H394.6C394.5 193 393.1 191.6 383.7 201 372.5 206.6 345.8 207.3 345.8 209.7 345.8 214.2 416.1 206.6 433.9 209.7 443.4 211.2 432.4 230.1 429.5 241.7 429 246.2 431.9 244 433.3 241.8zM321.2 264.4C385.2 243.1 418.5 240.5 423.2 238.2 427.6 235.3 418.8 231.6 397 232.4 345.3 234.6 259.4 269.5 224.4 286.3L193.7 193H390.3C387.6 164.8 237.4 170.4 52.4 170.4L0 415.9C196.4 318.6 258.9 285.6 321.2 264.4zM67.7 96.1C321 149.8 397.7 161.8 399.8 181.3 436.2 181.3 445.7 181.3 452.2 187.9 473.3 207.6 437.6 255.6 437.6 255.6 433.2 258.5 31.2 415.8 31.2 415.8H454.3L522 96.1H67.7z'
      }
    ]
  }
})
